import { ReactComponent as ReportSectionBullet } from "assets/svg/report-section-bullet.svg";

import { ReportItemType } from "types/Reports";
import { REPORT_SENSOR_REGISTRY } from "constant/report";

type ReportBulletTextProps = {
    itemType: ReportItemType;
    highlightClassName: string;
    isOverview: boolean;
};

export default function ReportBulletText({
    itemType,
    highlightClassName,
    isOverview,
}: Readonly<ReportBulletTextProps>) {
    const bulletText = REPORT_SENSOR_REGISTRY[itemType].bullet;

    return (
        <section className={isOverview ? 'report-bullet-text ' : 'report-bullet-text--tab'}>
            <ReportSectionBullet className={highlightClassName} />
            <span>{` ${bulletText}`}</span>
        </section>
    );
}
